import React from 'react';
import Header from '../components/Header';
import bgtrace from '../assets/bgtrace1.jpeg';

const ShopLocation = () => {
  const handleMapClick = () => {
    window.open('https://maps.google.com/?q=1409+Broadway,+Suite+101,+Chula+Vista,+CA+91911', '_blank');
  };

  return (
    <div className="min-h-screen">
      <Header />
      
      <main 
        className="pt-20 pb-16 px-4 sm:px-6 lg:px-8"
        style={{
          backgroundImage: `url(${bgtrace})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="text-center pt-20 pb-10">
          <h1 className="text-5xl font-extrabold">
            Visit <span className="text-red-600">Taco Garage</span>
          </h1>
          <p className="mt-4 text-gray-700 max-w-2xl mx-auto">
            You can find us inside the South Bay Autoplex. Use the map below to get directions.
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white/95 text-gray-900 shadow-xl rounded-xl p-8 mt-6 mb-20 backdrop-blur-sm">
          <div 
            onClick={handleMapClick}
            className="cursor-pointer rounded-xl overflow-hidden border border-gray-300 shadow-md hover:shadow-lg transition-shadow duration-300"
          >
            <iframe
              title="Taco Garage Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13498.09287937004!2d-117.0791592322975!3d32.60102525100762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d94f51c9e3297b%3A0xb29c6943c77f9625!2sTaco%20Garage!5e0!3m2!1sen!2sus!4v1690927278005!5m2!1sen!2sus"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ShopLocation;
